import * as React from "react";
import { Text } from "@uikit";
import { IOption } from "@kalabo/golfsavers-common";
import { CheckCircleIcon } from "@heroicons/react/solid";

interface IProps {
  title?: string;
  options: IOption[];
  value: any;
  onChange: (value: any) => void;
  multiple?: boolean;
  disabled?: boolean;
}

const MultiSelectButton = ({
  title,
  options,
  value,
  onChange,
  multiple = false,
  disabled = false,
}: IProps) => {
  return (
    <div className="mb-10">
      {title && (
        <Text
          size={17}
          element="h3"
          weight="semibold"
          leading={1.3}
          color="black90"
          className="mb-1"
        >
          {title}
        </Text>
      )}
      <div className="flex flex-col gap-[5px]">
        {options.map((option: IOption, index: any) => {
          return (
            <div
              key={index}
              onClick={() => {
                onChange(option.value);
              }}
              className={`${
                value === option.value ? "border-blue" : "border-grey2 "
              } border-[1px] rounded-[4px] px-3 py-[18px] cursor-pointer flex items-center justify-between`}
            >
              <div className="flex flex-col flex-1">
                <Text
                  size={15}
                  weight="semibold"
                  leading={1.3}
                  color="black80"
                  className="relative py-1"
                >
                  {option.text}

                  {value === option.value && (
                    <CheckCircleIcon className="w-[26px] text-blue absolute top-0 right-0" />
                  )}
                </Text>
                {option.description && (
                  <Text size={13} leading={1.5} color="black90">
                    {option.description}
                  </Text>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MultiSelectButton;
